const instrumentGroupsReducer = (state = [{code: "ALL", description: "All"}], action) => {
  switch (action.type) {
    case 'LANDLINK_INSTRUMENT_GROUPS':
      return action.results;
    default:
      break;
  }
  return state;
}

export default instrumentGroupsReducer;